import { FragmentPaginator } from "@ext/markdown/elements/fragment/print/FragmentPaginator";
import { NotePaginator } from "@ext/markdown/elements/note/print/NotePaginator";
import { ChainPaginator } from "@ext/markdown/elements/openApi/print/OpenApiPaginator";
import { TabsPaginator } from "@ext/markdown/elements/tabs/print/TabsPaginator";
import type NodePaginator from "@ext/print/utils/pagination/NodePaginator";

// Their copy of the chrome joins the page only when the run is over, so an empty one says nothing about the page.
// An OpenAPI card's body is such a run inside another: without it, every paragraph opening the body looked like
// the top of an empty page and was forced onto one it did not fit.
const paginatorsWithoutAutoPageCreation = [FragmentPaginator, NotePaginator, TabsPaginator, ChainPaginator];

const someParentHaveChildNodes = (paginator: NodePaginator) => {
	let parent = paginator.parentPaginator;
	if (parent.haveChildNodes()) return true;
	while (parent) {
		if (
			paginatorsWithoutAutoPageCreation.some((P) => parent instanceof P) &&
			(parent as NodePaginator).parentPaginator.haveChildNodes()
		) {
			return true;
		}
		parent = (parent as NodePaginator).parentPaginator;
	}
};

export default someParentHaveChildNodes;
